import { sdkHooks } from '../sdkHooks';
const emptyGame = (id) => ({
    id,
    title: 'Unknown Game',
    description: 'No description available.',
    tags: [],
    creators: [],
    prerelease: false,
    versions: [
        {
            version: 'v1',
            url: 'http://localhost:3100/noop',
        },
    ],
    screenshots: [],
});
export function useGame(id) {
    const { data: gameData } = sdkHooks.useGetGame({
        id: id ?? '',
    });
    if (!id) {
        return emptyGame('empty');
    }
    return gameData ?? emptyGame(id);
}
export function useGameVersion(id, version) {
    const game = useGame(id);
    return (game.versions.find((v) => v.version === version) ?? {
        version,
        minimumPlayers: 1,
        maximumPlayers: 100,
    });
}
//# sourceMappingURL=useGame.js.map